import { EventType, PublicClientApplication } from "@azure/msal-browser";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import store from "./app/store";
import { msalConfig } from "./authConfig";
import "./index.css";
export const msalInstance = new PublicClientApplication(msalConfig);

if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
 msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

msalInstance.enableAccountStorageEvents();

msalInstance.addEventCallback((event) => {
 if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
  const account = event.payload.account;
  msalInstance.setActiveAccount(account);
 }
});

ReactDOM.render(
 <React.StrictMode>
  <Router>
   <Provider store={store}>
    <App pca={msalInstance} />
   </Provider>
  </Router>
 </React.StrictMode>,
 document.getElementById("root")
);
